import React from 'react';

export default function StatusIconRateLimited({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 21"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Source-Slideout-Panel-View"
          transform="translate(-1214.000000, -231.000000)"
          fill={color}
        >
          <path
            d="M1227.70495,239.247374 L1223.00212,239.247374 C1222.58787,239.247374 1222.25079,238.910293 1222.25079,238.496048 L1222.25079,231.750474 C1222.25079,231.019463 1221.31671,230.722991 1220.89028,231.315934 L1214.14055,242.187742 C1213.78723,242.683206 1214.14055,243.373608 1214.74973,243.373608 L1219.4405,243.373608 C1219.85475,243.373608 1220.19183,243.710689 1220.19183,244.124935 L1220.19183,250.874666 C1220.19183,251.605677 1221.12591,251.902149 1221.55234,251.309206 L1228.31829,240.43324 C1228.66756,239.937776 1228.31423,239.247374 1227.70505,239.247374 L1227.70495,239.247374 Z"
            id="Paused-Status-Icon"
          ></path>
        </g>
      </g>
    </svg>
  );
}

StatusIconRateLimited.defaultProps = {
  width: '15px',
  height: '20px',
  color: '#000000',
};
